export default {
  employees: "Cashiers",
  noCreatedYet: "No cashiers created yet",
  downloadAppRCKassa: "Download RC KASSA App",
  downloadRCKassa: "Download RC KASSA",
  addingEmployee: "Adding Cashier",
  toCreateEmployeeNeedPoint:
    "At least one trading point is required to create a cashier",
  secondName: "Cashier's Last Name",
  firstName: "Cashier's First Name",
  toTradingPoints: "To Trading Points",
  uWantToDeleteEmployee: "Are you sure you want to delete the cashier?",
  personName: "Last and First Name",
  blockAccess: "Block Access",
  openAccess: "Open Access",

  employeeScore: "Cashier Points",
  points: "points",
  debiting: "Debit",
  accrual: "Accrual",
};
